import { createAsyncAction } from "typesafe-actions";
import PurchaseCouponRequest from "../../models/coupon/PurchaseCouponRequest";
import { PurchaseCouponActionTypes } from "./types";

export const purchaseCouponActions = createAsyncAction(
    PurchaseCouponActionTypes.REQUEST,
    PurchaseCouponActionTypes.SUCCESS,
    PurchaseCouponActionTypes.ERROR
)<PurchaseCouponRequest, any, any>();
